module.exports = __webpack_public_path__ + "media/images/icon_list/circle_close-d7d1f7683b7df72aee121aa0e8795e02.svg";